import { Component, Input } from '@angular/core';
import { ColumnSettings } from '../../common/models';

@Component({
  selector: 'boolean-editor',
  templateUrl: './boolean-editor.component.html',
  styleUrls: ['./boolean-editor.component.scss']
})
export class BooleanEditorComponent {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;
}
